/** HO's stock pages (FR-STK-02, FR-RPT-06, ADR 0100), from what the stores pushed. */
export const HO_STOCK_PATHS = {
  balances: '/reports/stock-balances',
  movements: '/reports/stock-movements',
  transfers: '/reports/stock-transfers',
  counts: '/reports/stock-counts',
} as const;
